import { render, staticRenderFns } from "./EditCossaVersion.vue?vue&type=template&id=6fac4a48"
import script from "./EditCossaVersion.vue?vue&type=script&lang=js"
export * from "./EditCossaVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports